import React from 'react';
import AccordionReferralCard from 'components/card/AccordionReferralCard';
import DetailItem from 'components/card/ItemDetail';
import { AssetVictim, EntityType, Referral } from 'types';
import { UserCard } from 'components/card/UserCard';

interface VictimCardProps {
  referralData?:Referral | null
  referralId?: string;
  handleButtonClick: (type:EntityType) => void;
  handleEdit: (type:EntityType, victim: AssetVictim) => void;
  handleDelete: (id: string, type:EntityType) => void;
  handleUserView: (user: any, title: string, description: string, children?: React.ReactNode) => void;
}

export default function VictimCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  handleDelete,
  handleUserView
}: VictimCardProps) {
  return (
    <AccordionReferralCard
      title={`Victims - ${referralData?.victims?.length || 0}`}
      buttonText="Add Victim"
      onButtonClick={() => handleButtonClick("victim")}
      disabled={
        !referralData ||
          [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.victims && referralData.victims.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.victims.map((victim) => (
            <UserCard
              key={victim.id}
              avatarUrl=""
              date={""}
              name={victim?.person?.full_name as string}
              role={victim?.person?.region as string}
              time={""}
              onDelete={() => handleDelete(victim?.id as string, "victim")}
              onEdit={() => handleEdit("victim", victim)}
              user={victim.person}
              title="Victim Details"
              description="Detailed information about victim"
             disabled={
                      ![
                        "Investigation Ongoing",
                        "Pending",
                        "Prohibition On Revision",
                      ].includes(referralData?.action_status as string)
                    }
              onView={() => handleUserView(
                victim.person,
                "Victims Details",
                "Detailed information about victims",
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {victim?.victim_name &&
                    victim.victim_name !== victim?.person?.full_name && (
                      <DetailItem
                        label="Victim Name"
                        value={victim.victim_name}
                      />
                    )}
                  {victim?.victim_type && (
                    <DetailItem
                      label="Victim Type"
                      value={victim.victim_type}
                    />
                  )}
                  {victim?.victim_condition && (
                    <DetailItem
                      label="Victim Condition"
                      value={victim.victim_condition}
                    />
                  )}
                  {victim?.victim_department && (
                    <DetailItem
                      label="Victim Department"
                      value={victim.victim_department}
                    />
                  )}
                </div>
              )}
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No victims added yet
        </div>
      )}
    </AccordionReferralCard>
  );
}